//import { random } from "lodash-es";
import moment from 'moment';

export const populateEvents = (e, c, rangeStart = null, rangeEnd = null) => {
  //console.log('EVENT', e);
  //console.log('KALENDAR', c);
  // prolazi kroz radno vreme i na svakih sat generiše termine
  // i na osnovu učitanih eventa daje da li su slobodni ili ne
  // iz kalendara čita max broj lokacija
  // daje zelenu boju za slobodan i crvenu za zauzet termin

 

  const bh = c.businessHours;
  const max_event_number = c.max_event_number;
  const start_days = c.start_days ? c.start_days : 2; // za koliko dana unapred da se generišu termini
  const durationMinutes = parseInt(c.event_duration_calendar, 10) || 30;
  const eventPerHour = 60 / durationMinutes;
  //console.log('eventPerHour', eventPerHour);
  const end_days = c.end_days ? c.end_days : 30; // 30 default durarion

  const parsedStartTime = moment(c.starttime, ['HH:mm:ss', 'HH:mm'], true);
  const startHour = parsedStartTime.isValid() ? parsedStartTime.hour() : 0;
  const startMinute = parsedStartTime.isValid() ? parsedStartTime.minute() : 0;

  const slotsStart = (rangeStart
    ? moment(rangeStart).startOf('day')
    : moment().startOf('date').add(start_days, 'd')
  )
    .hour(startHour)
    .minute(startMinute)
    .second(0)
    .millisecond(0);
  const slotsEnd = rangeEnd
    ? moment(rangeEnd)
    : moment(slotsStart).add(end_days, 'd');
  const totalMinutes = Math.max(slotsEnd.diff(slotsStart, 'minutes'), durationMinutes);
  const numberOfEvents = Math.ceil(totalMinutes / durationMinutes);
  //console.log('numberOfEvents', numberOfEvents);

  // proverava da li je u radnom vremenu
  // ako jeste vraca true ako nije false
  const isInBh = (dofw, t) => {
    // console.log('dofw', dofw);
    // console.log('T', t);
    const _time = moment(t).format('HH:mm');
    const _show = bh
      .filter(a => a.daysOfWeek.includes(dofw + 1))
      .map(d => {
        return { start: d.startTime, end: d.endTime };
      });
    const _wh = _show[0];

    if (_wh) {
      if (_wh.start <= _time && _time < _wh.end) {
        return true;
      } else return false;
    } else return false;
  };

  const isInBreakTime = (dofw, t) => {
    const _time = moment(t).format('HH:mm');
    const _show = bh
      .filter(a => a.daysOfWeek.includes(dofw + 1))
      .map(d => {
        return { start: d.break_start_time, end: d.break_end_time };
      });
    const _wh = _show[0];

    if (_wh && _wh.start && _wh.end) {
      if (_wh.start <= _time && _time < _wh.end) {
        return true;
      }
    }
    return false;
  };
  // proverava da li je termin popunjen
  const fullTermin = t => {
    if (e) {
      const countE = e.filter(a => {
        // console.log('A', a, 'T', t);
        return moment(a.start).format() === moment(t).format();
      });

      if (max_event_number <= countE.length) return true;
      else return false;
    } else return false;
  };

  // end_days * broj dna * broj termina u satu
  const _nextDays = new Array(numberOfEvents).fill(null).map((x, i) => {
    const event = {};
    event.day = moment(slotsStart)
      .add(i * durationMinutes, 'minutes')
      .format();

    const dayOfWeek = moment(event.day).weekday();
    event.show = isInBh(dayOfWeek, event.day);
    const inBreakTime = isInBreakTime(dayOfWeek, event.day);
    //  kalendar ima postojecih eventa za ovaj termin
    // console.log('BROJ TERMINA', fullTermin(event.day))
    if ((event.show && fullTermin(event.day)) || inBreakTime) {
      event.disabled = false;
      event.color = 'red';
    } else {
      event.disabled = true;
      event.color = 'green';
    }

    return event;
  });

  // console.log('svimoguciterminie', _nextDays);

  const _events = _nextDays
    .filter(a => a.show)
    .map(d => {
      const event_end = moment(d.day).add(durationMinutes, 'minutes');
      return { id: Math.random(), start: d.day, end: event_end._d, color: d.color, disabled: d.disabled, rendering: d.rendering };
    });

  //console.log('svimoguciterminie', _events);

  return _events;
};
